import { useGet } from "@/api/lib/integration";
import type { Bedarfsinfo } from "@/bedarf/types/bedarfsinfo";
import type { VerlaufLink } from "@/bedarf/types/verlauf";

import type { ThemenMenuItem } from "@/api/mein-bedarf/types";

export const getBedarfsinfoFor = useGet<{sparte: string, bedarfHash: string }, Bedarfsinfo>('/api/mein-bedarf/{bedarfHash}/{sparte}');
export const getBeratungsdaten = useGet<{ bedarfHash?: string }, { themen: ThemenMenuItem[], verlauf: VerlaufLink[], bearbeitbar: boolean }>('/api/mein-bedarf');
